import React from 'react'

const FacilitiesTabs = () => {
  return (
    <div>FacilitiesTabs</div>
  )
}

export default FacilitiesTabs